import styled from "styled-components";

export const AppContainer = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 340px auto auto;
  grid-template-rows: 48px 52px auto auto; /* ← добавлена высота для hdr */
  grid-template-areas: 
    "hdr  hdr  hdr"     /* ← новая строка */
    "fltr srch srch"
    "fltr grd grd"
    "fltr grd grd";

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* ← лучше явно указать одну колонку */
    grid-template-rows: auto;   /* ← строки будут определяться по контенту */
    grid-template-areas: 
      "hdr"
      "fltr"
      "srch"
      "grd";
  }

  & * {
    text-transform: initial;
    letter-spacing: normal;
    box-sizing: border-box;
  }
`
export const ProductionTypeFilterContainer = styled.div`
  grid-area: hdr;
`
